import React from 'react';

import styled from '@emotion/styled';
import { mq, black02, green01, grayBg, black03, text } from '../../_style';
import { css } from '@emotion/core';

export default class StimulationLevel extends React.Component {
  render() {
  const Container = styled.div`
    display: flex;
    align-items: center;
    * + & {
      margin-top: 30px;
    }
    & > span {
      font-size: 12px;
      line-height: 1;
    }
  `;
  const Points = styled.div`
    color: ${green01};
    width: 181px;
    height: 12px;

    position: relative;

    &::before, &::after {
      position: absolute;
      top: calc(100% + 5px);
      ${text('12px', 1)};
      color: ${black03};
    }

    &::before {
      content: 'やさしい';
      left: 0;
    }

    &::after {
      content: '強い';
      right: 0;
    }

    ${mq.sp} {
      width: 192px;
    }
    background: #e5e5e5;
    & > span {
      display: block;
      height: 12px;
      width: ${this.props.level / 7 *100}%;
      background-color: currentColor;
    }
  `

    return (
      <>
        <Container>
          <span>{this.props.isLp ? '刺激レベル' : '刺激レベル：'}</span>
          <Points>
            <span></span>
          </Points>
        </Container>
      </>
    );
  }
}
